import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { DashCounters } from '@apps/auth/domain/models/back/dash-counters';
import { Entity } from '@apps/auth/domain/models/back/entity';

export const BackAuthCountersRequested = createAction(
    '[BACK-AUTH-COUNTERS] Back Auth Counters Requested'
);

export const BackAuthCountersLoaded = createAction(
    '[BACK-AUTH-COUNTERS] Back Auth Counters Loaded',
    props<{ entitiesCounters: DashCounters, usersCounters: DashCounters }>()
);

export const BackAuthEntitiesInternalODataRequested = createAction(
    '[BACK-AUTH-ENTITIES] Back Auth Entities Internal OData Requested'
);

export const BackAuthEntitiesInternalODataLoaded = createAction(
    '[BACK-AUTH-ENTITIES] Back Auth Entities Internal OData Loaded',
    props<{ entities: Entity[] }>()
);
export const BackAuthEntitiesInternalQsWordSet = createAction(
    '[BACK-AUTH-ENTITIES] Back Auth Entities Internal QsWord Set',
    props<{ qsWord: string }>()
);

export const BackAuthEntityInternalUpdated = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Internal Updated',
    props<{ entity: Update<Entity> }>()
);
